const StoreAddressConfig = {
  'store.address.back': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '返回',
    c: {
      type: 'constant',
      value: 'prev',
    },
  },
  'store.address.upsert': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '添加新地址',
    c: {
      type: 'constant',
      value: 'address_upsert',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `u=${traceData?.u || ''}`;
      },
    },
  },
  'store.address.search': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '添加新地址',
    c: {
      type: 'constant',
      value: 'address_search',
    },
  },
  'store.address.select': {
    operation: ['VISIBLE'],
    title: '当前地址',
    c: {
      type: 'constant',
      value: 'address_pin',
    },
  },
  'store.address.relocal': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '当前地址',
    c: {
      type: 'constant',
      value: 'address_set',
    },
  },
  'store.address.more': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '更多地址',
    c: {
      type: 'constant',
      value: 'address_ext',
    },
    iid: {
      type: 'variable',
      func: function getIid(traceData) {
        return `u=${encodeURIComponent(traceData?.u || '')}`;
      },
    },
  },
  'store.address.result.list': {
    operation: ['VISIBLE'],
    title: '地址搜索结果大列表',
    c: {
      type: 'constant',
      value: 'address_sug',
    },
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const data = {
          type: 'address_sug',
          isViewable: item.isViewable,
          key: 'address_sug' + item?.index,
          index: item?.index,
          iid: 'id=',
          b: 'address_search',
          c: 'address_sug',
          d: item?.index,
        };
        return [data];
      },
    },
  },
  'store.address.result.touch': {
    operation: ['TOUCH'],
    title: '搜索结果点击',
    c: {
      type: 'constant',
      value: 'address_sug',
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        return traceData.d;
      },
    },
  },

  'store.address.login': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '登录的点击',
    c: {
      type: 'constant',
      value: 'address_unauth',
    },
  },

  'store.address.ownaddress_touch': {
    operation: ['TOUCH'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'address_own',
    },
    iid: {
      type: 'variable',
      func: function (traceData) {
        const { addressId } = traceData;
        return `address_id=${addressId}`;
      },
    },
  },
  'store.address.address_nearby_touch': {
    operation: ['TOUCH'],
    title: '点击',
    c: {
      type: 'constant',
      value: 'address_nearby',
    },
  },

  // 搜索前的地址列表
  'store.address.list': {
    operation: ['VISIBLE'],
    title: '地址大列表搜索前',
    c: {
      type: 'constant',
      value: 'address_own',
    },
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        let data = null;
        if (item?.section?.sectionHeader?.key === 'userAddress') {
          if (item?.item?.addressId) {
            return [];
          }
          data = {
            type: 'address_own',
            isViewable: item.isViewable,
            key: 'address_own' + item?.index,
            index: item?.index,
            iid: `address_id=${item?.item?.addressId}`,
            b: 'address_search',
            c: 'address_own',
            d: item?.index,
          };
        } else if (item?.section?.sectionHeader?.key === 'aroundAddress') {
          data = {
            type: 'address_nearby',
            isViewable: item.isViewable,
            key: 'address_nearby' + item?.index,
            index: item?.index,
            iid: 'id=',
            b: 'address_search',
            c: 'address_nearby',
            d: item?.index,
          };
        }
        return [data];
      },
    },
  },

  // 去定位
  'store.address.address_own_locate': {
    operation: ['VISIBLE', 'TOUCH'],
    title: '去定位',
    c: {
      type: 'constant',
      value: 'address_own_locate',
    },
    d: {
      type: 'variable',
      func: function (traceData) {
        return traceData.d;
      },
    },
  },
};

export default StoreAddressConfig;
